import type { ContactInfo } from '@shared/contact-form'
import { publicContactInfo } from '../../../../sedi/placeholders'
import type { SedeConfig } from '../../../../sedi/types'
import type { Locale } from '../../content/types'
import { legalEntityFor } from '../../../../legal/entity'
import { pathFor } from '../../routes'

/**
 * What the shared form is told about this sede. Pure (no React, no DOM),
 * so formContactInfo.test.ts checks it against the real config.
 *
 * - Data controller: both `owner` and `addressLine` come from
 *   `legalEntityFor`, the same source as the /privacy/ page, so the consent
 *   sentence and the policy it links to name the same controller: Verde
 *   Vercelli di Andrea Vetri, Via dei Ciudin 8, 13100 Vercelli (VC).
 * - Phone: gated by the legal entity (`entity.phone`), so the form and the
 *   legal pages agree; a placeholder is never passed (an absent `phone` would
 *   fall back to the form's i18n `footer.phone`), it is blanked instead and
 *   the form skips its phone row. On the dev server only (Vite MODE
 *   'development'), the config's value is shown; builds and tests never see
 *   a placeholder.
 * - Panel: always shown (owner, 2026-09-24).
 */
export function formContactInfo(
  sede: SedeConfig,
  locale: Locale,
): { contactInfo: ContactInfo; hideInfoPanel: boolean } {
  const entity = legalEntityFor(sede, locale)
  const place = entity.cityLine
  return {
    contactInfo: {
      ...publicContactInfo(sede),
      owner: entity.legalName,
      addressLine: entity.street ? `${entity.street}, ${place}` : place,
      phone: entity.phone ?? (import.meta.env.MODE === 'development' ? sede.contact.phone : ''),
      privacyPolicyUrl: pathFor('privacy', locale),
    },
    hideInfoPanel: false,
  }
}
